export const BUTTON_LABELS = {
    "GENERATE_PASSWORD": "Auto-generate new password",
    "PROTECT_THIS_FILE": "Password protect this page",
    "UN_PROTECT_THIS_FILE": "Unprotect this page",
}

export const MESSAGES = {
    "COPY_PASSWORD_TO_CLIPBOARD": "Great! You’ve successfully copied the password to clipboard.",
	"COPY_BYPASS_URL_TO_CLIPBOARD": "Great! You've successfully copied the access link to clipboard.",
	"CONFIRM_DELETE_PASSWORD": "Are you sure to delete this password?",
    "CONFIRM_DELETE_PASSWORDS": "Are you sure to delete these passwords?",
    "CONFIRM_DELETE_ALL_EXPIRED_PASSWORDS": "Are you sure to delete all the expired passwords?",
    "ERROR_DELETE_ALL_EXPIRED_PASSWORDS": "An error occurred, or no expired passwords were detected",
    "FILE_TO_CONFIG": "You're protecting ",
    "PROTECT_FILE": "Great! You've successfully protected this page.",
    "UN_PROTECT_FILE": "Great! You've successfully unprotected this page.",
    "DEFAULT_ERROR_MESSAGE": "Opps! Something went wrong."
}

export const TABS = {
    TABLE: 0,
    FORM: 1,
    FILE_ACCESS_PERMISSION: 2
}



// WEBPACK FOOTER //
// ./utils/strings.js